import MqInit from "styled-components-media-query";
const bp = { s: 768, m: 1024, l: 1280 };
const mq = MqInit({ bp });
export default mq;
